export default __webpack_public_path__ + "static/media/institute-8-min.32b2d63f.webp";